/* eslint-disable */
const tableInit = (table: HTMLElement) => {
    var parent = table.parentNode;
    var wrapper = document.createElement('div');
    wrapper.style.overflowX = 'auto'; 
    parent.insertBefore( wrapper, table );
    wrapper.appendChild(table);
};

export default tableInit;
